module.exports = __webpack_public_path__ + "static/img/rabbit.d1b2ddce.png";